<template>
  <div
    class="w-3/4 flex gap-2 items-center"
    :class="{ 'non-editable': !isEditing }">
    <div class="h-full mb-1">{{ pretext }}</div>
    <BaseTextArea
      v-model="model"
      class="w-full grow-0 gap-2"
      :placeholder="placeholder"
      :editable="isEditing"
      :allow-enter="false"
      @blur="isEditing = false"
      @keyup.enter="isEditing = false"/>
    <button v-if="!isEditing" @click="isEditing = !isEditing">
      <Pencil width="14" height="14" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Pencil } from 'lucide-vue-next';
import BaseTextArea from '@/components/Textarea/BaseTextArea.vue';
import { useVModel } from '@vueuse/core';

interface IProps {
  modelValue: string;
  placeholder: string;
  pretext: string;
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: '',
  placeholder: '',
  pretext: '',
});

const emit = defineEmits(['update:modelValue']);

const model = useVModel(props, 'modelValue', emit);

const isEditing = ref(false);
</script>

<style scoped>
.non-editable :deep(.headline) {
  @apply bg-white border-none;
}

.non-editable :deep(div:has(.group\/headline)) {
  @apply w-auto;
}

.non-editable :deep(.group\/headline) {
  @apply min-w-20;
}
</style>
